import React, { useEffect, useRef, useState } from 'react';
import './SecurityTrust.css';

/* ── SVG Icons ── */

const ShieldKickerIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 2L4 6V11C4 17 7.5 20.5 12 22.5C16.5 20.5 20 17 20 11V6L12 2Z"
      stroke="#2563EB"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M8.5 12L11 14.5L15.5 9.5"
      stroke="#2563EB"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const EncryptionIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g className="lock-shackle">
      <path
        d="M16 20V16C16 11.582 19.582 8 24 8C28.418 8 32 11.582 32 16V20"
        stroke="#60A5FA"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <rect
      x="12"
      y="20"
      width="24"
      height="18"
      rx="3"
      stroke="#2563EB"
      strokeWidth="2"
    />
    {/* Keyhole */}
    <circle cx="24" cy="28" r="2.5" fill="#60A5FA" />
    <rect x="23" y="30" width="2" height="4" rx="1" fill="#60A5FA" />
    <path
      className="lock-check"
      d="M20 29L23 32L28 26"
      stroke="#059669"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const InboxPrivacyIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g className="shield-body">
      <path
        d="M24 6L10 12V22C10 32.5 16 38.5 24 42C32 38.5 38 32.5 38 22V12L24 6Z"
        stroke="#2563EB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Small checkmark inside */}
      <path
        className="shield-check"
        d="M19 24L22.5 27.5L29 21"
        stroke="#059669"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <line
      className="scan-line"
      x1="14"
      y1="16"
      x2="34"
      y2="16"
      stroke="#60A5FA"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const UserControlIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Slider track 1 */}
    <line x1="12" y1="14" x2="36" y2="14" stroke="#E5E7EB" strokeWidth="4" strokeLinecap="round" />
    <circle cx="20" cy="14" r="4" fill="#2563EB" stroke="#2563EB" strokeWidth="1" />

    {/* Slider track 2 - animated */}
    <line x1="12" y1="24" x2="36" y2="24" stroke="#E5E7EB" strokeWidth="4" strokeLinecap="round" />
    <g className="toggle-knob">
      <circle cx="20" cy="24" r="4" fill="#2563EB" stroke="#2563EB" strokeWidth="1" />
    </g>
    <circle className="toggle-dot" cx="30" cy="24" r="2.5" fill="#059669" />

    {/* Slider track 3 */}
    <line x1="12" y1="34" x2="36" y2="34" stroke="#E5E7EB" strokeWidth="4" strokeLinecap="round" />
    <circle cx="28" cy="34" r="4" fill="#2563EB" stroke="#2563EB" strokeWidth="1" />
  </svg>
);

const DisconnectIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g className="plug-left">
      <path
        d="M10 24H20L22 20V28L20 24"
        stroke="#2563EB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line x1="16" y1="20" x2="16" y2="16" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" />
      <line x1="16" y1="28" x2="16" y2="32" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" />
    </g>
    {/* Gap between halves */}
    <line className="plug-gap" x1="24" y1="19" x2="24" y2="29" stroke="#DC2626" strokeWidth="1.5" strokeLinecap="round" strokeDasharray="2 3" />
    <g className="plug-right">
      <path
        d="M38 24H28L26 20V28L28 24"
        stroke="#2563EB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line x1="32" y1="20" x2="32" y2="16" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" />
      <line x1="32" y1="28" x2="32" y2="32" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" />
    </g>
    <circle className="plug-flash" cx="24" cy="24" r="3" fill="#DC2626" />
  </svg>
);

/* ── Badge icons ── */

const ShieldBadgeIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M8 1L2 4V7.5C2 11.5 4.5 14 8 15.5C11.5 14 14 11.5 14 7.5V4L8 1Z" stroke="#2563EB" strokeWidth="1.2" strokeLinejoin="round" />
    <path d="M5.5 8L7 9.5L10.5 6" stroke="#059669" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const LockBadgeIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <rect x="3" y="7" width="10" height="7" rx="1.5" stroke="#2563EB" strokeWidth="1.2" />
    <path d="M5 7V5C5 3.343 6.343 2 8 2C9.657 2 11 3.343 11 5V7" stroke="#2563EB" strokeWidth="1.2" strokeLinecap="round" />
  </svg>
);

/* ── Card data ── */

const CARDS = [
  {
    key: 'encryption',
    className: 'security-card--encryption',
    Icon: EncryptionIcon,
    title: 'Encrypted end-to-end',
    desc: 'AES-256 encryption. Your password never touches our servers\u00A0\u2014 not even encrypted. We use OAuth tokens only.',
  },
  {
    key: 'privacy',
    className: 'security-card--privacy',
    Icon: InboxPrivacyIcon,
    title: 'We never read your emails',
    desc: 'We request send-only permissions via Google OAuth. We literally cannot see your inbox, drafts, or attachments\u00A0\u2014 the API doesn\u2019t allow it.',
  },
  {
    key: 'control',
    className: 'security-card--control',
    Icon: UserControlIcon,
    title: 'You approve everything',
    desc: 'Preview every email before it sends. Edit the subject, body, or recipient. One click to approve, one click to skip.',
  },
  {
    key: 'disconnect',
    className: 'security-card--disconnect',
    Icon: DisconnectIcon,
    title: 'Disconnect in one click',
    desc: 'One button in your dashboard. We delete your tokens instantly\u00A0\u2014 no 30-day retention, no hidden data, no exit interview.',
  },
];

const BADGES = [
  { label: 'SOC 2', Icon: ShieldBadgeIcon },
  { label: 'GDPR', Icon: ShieldBadgeIcon },
  { label: 'SSL Secured', Icon: LockBadgeIcon },
];

/* ── Component ── */

function SecurityTrust() {
  const cardsRef = useRef([]);
  const [visible, setVisible] = useState([]);

  useEffect(() => {
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (mq.matches) {
      setVisible(CARDS.map((_, i) => i));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const idx = Number(entry.target.dataset.idx);
            setVisible((prev) => (prev.includes(idx) ? prev : [...prev, idx]));
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    cardsRef.current.forEach((el) => {
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section className="security-section">
      <div className="security-section__inner">
        {/* Header */}
        <p className="security-section__kicker">
          <ShieldKickerIcon />
          SECURITY
        </p>
        <h2 className="security-section__heading">
          <span className="security-section__heading--dark">Your data is safe.</span>{' '}
          <span className="security-section__heading--blue">Your inbox is yours.</span>
        </h2>
        <p className="security-section__subtitle">
          We never see your password. We can&rsquo;t read your inbox. Here&rsquo;s
          exactly what we do and don&rsquo;t access.
        </p>

        {/* Cards */}
        <div className="security-section__cards">
          {CARDS.map((card, i) => {
            const isVisible = visible.includes(i);
            const animClass = isVisible
              ? 'security-card--animate-in'
              : 'security-card--animate-ready';

            return (
              <div
                key={card.key}
                ref={(el) => { cardsRef.current[i] = el; }}
                data-idx={i}
                className={`security-card ${card.className} ${animClass}`}
                style={{ transitionDelay: `${i * 100}ms` }}
              >
                <div className="security-card__icon-wrap">
                  <card.Icon />
                </div>
                <h3 className="security-card__title">{card.title}</h3>
                <p className="security-card__desc">{card.desc}</p>
              </div>
            );
          })}
        </div>

        {/* Trust badges */}
        <div className="security-section__badges">
          {BADGES.map((badge) => (
            <span key={badge.label} className="trust-badge">
              <badge.Icon />
              {badge.label}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}

export default SecurityTrust;
